import React, { useEffect, useState, } from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import GroupIcon from '@mui/icons-material/Group';
import CardInfo from 'app/components/CardInfo';
import CardNotifications from 'app/components/CardNotifications';
import { request } from 'app/utils/core';
import { validInt } from 'app/utils/helpers';
import { ProjectForCustomerItem } from './ProjectForCustomerItem';
import { useTranslation } from 'react-i18next';
// import InputEnterHours from 'app/components/InputEnterHours';

const PayrollDashboard = ({ setLoading, sweetAlerts }) => {

  const { t } = useTranslation();
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [totalProjects, setTotalProjects] = useState(0);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [totalActiveProjects, setTotalActiveProjects] = useState(0);
  const [projectsForStatus, setProjectsForStatus] = useState([]);
  const [employeeForStatus, setEmployeeForStatus] = useState([]);
  const [projectsForCustomers, setProjectsForCustomers] = useState([]);

  const fnGetData = () => {

    setLoading(true);
    request.GET('/dashboard', resp => {
      const { qtyActiveEmployees, qtyActiveCustomers, activeProjects } = resp;
      setTotalEmployees(qtyActiveEmployees);
      setTotalCustomers(qtyActiveCustomers);
      let totalProjects = 0;
      const countActiveProjects = activeProjects.map(item => {
        totalProjects += validInt(item.qtyProjects);
        return {
          id: item.customerId,
          value: item.qtyProjects,
          name: item.customerName
        };
      });
      setProjectsForCustomers(countActiveProjects);
      setTotalActiveProjects(totalProjects);
      setTotalProjects(totalProjects);
      setLoading(false);
    }, err => {
      setLoading(false);
      console.error(err);
    });
  }

  useEffect(() => {

    fnGetData();

  }, [])


  return (
    <>
      <Card>
        <CardContent>
          <Typography variant='h3'>{t("appDashboard.payrollTitle")}</Typography>
        </CardContent>
      </Card>
      <Grid style={{ marginTop: "5px" }} container spacing={3} direction="row">
        <Grid item xs={12} sm={4}>
          <CardInfo
            gradientColorInit="#68C5EA"
            gradientColorEnd="#32A7B8"
            titleNumber={totalCustomers}
            titleDescription='Customers'
            icon={<SensorOccupiedIcon sx={{ fontSize: 36 }} />}
            listItems={[]}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CardInfo
            gradientColorInit="#56BA8A"
            gradientColorEnd="#1AA25F"
            titleNumber={totalProjects}
            titleDescription='Projects'
            icon={<DeveloperBoardIcon sx={{ fontSize: 36 }} />}
            listItems={projectsForStatus}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CardInfo
            gradientColorInit="#9FC5E8"
            gradientColorEnd="#127CD9"
            titleNumber={totalEmployees}
            titleDescription='Employees'
            icon={<GroupIcon sx={{ fontSize: 36 }} />}
            listItems={employeeForStatus}
          />
        </Grid>
      </Grid >
      <Grid style={{ marginTop: "5px" }} container spacing={3} direction="row">
        <Grid item xs={12}>
          <CardNotifications title={"card.activeProjects.title"} labelChip={totalActiveProjects} colorChip={"primary"}>
            <Grid container spacing={2} direction="row">
              {projectsForCustomers.map((elem, idx) => {
                let idxItemRef = `dash-payroll-prj-item-${Math.random()}-${idx}`;
                return <Grid item xs={6} sm={4} >
                  <ProjectForCustomerItem id={idxItemRef} itemData={elem} />
                </Grid>
              }
              )}
            </Grid>
          </CardNotifications>
        </Grid>
      </Grid>
      {/* <InputEnterHours /> */}
    </>
  );
};

export default PayrollDashboard;